import { dew as _nodeDew } from "../../errors/node.js";
import { dew as _transactionDew } from "../../errors/transaction.js";
import { dew as _getNodeErrorDew } from "./getNodeError.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getTransactionError = void 0;
  const node_js_1 = _nodeDew();
  const transaction_js_1 = _transactionDew();
  const getNodeError_js_1 = _getNodeErrorDew();
  function getTransactionError(err, {
    docsPath,
    ...args
  }) {
    const cause = (() => {
      const cause = (0, getNodeError_js_1.getNodeError)(err, args);
      if (cause instanceof node_js_1.UnknownNodeError) return err;
      return cause;
    })();
    return new transaction_js_1.TransactionExecutionError(cause, {
      docsPath,
      ...args
    });
  }
  exports.getTransactionError = getTransactionError;
  //# sourceMappingURL=getTransactionError.js.map
  return exports;
}